<template>
  <div class="flex flex-col gap-2">
    <div class="flex flex-row gap-2">
      <div
        class="flex-1 bg-untitled-gray-100 animate-pulse rounded-md h-32 relative"
      >
        <LoadingWrapper />
      </div>
      <div
        class="flex-1 bg-untitled-gray-100 animate-pulse rounded-md h-32 relative"
      >
        <LoadingWrapper />
      </div>
    </div>
    <div class="flex flex-row gap-2">
      <div
        class="flex-1 bg-untitled-gray-100 animate-pulse rounded-md h-32 relative"
      >
        <LoadingWrapper />
      </div>
      <div
        class="flex-1 bg-untitled-gray-100 animate-pulse rounded-md h-32 relative"
      >
        <LoadingWrapper />
      </div>
    </div>
  </div>
</template>

<script setup>
import LoadingWrapper from "@/components/utilities/LoadingWrapper.vue";
</script>

<style lang="scss" scoped></style>
